<!--
* @description  tabs 标签
* @fileName  tabsItem  有下划线、点、全边框、可选择背景 模式
* @author zlj
* @date 2022-02-22 10:11:51
!-->
<template>
  <div id='tabsItem' class='tabsItem' :style="[styleObject]" @click="clickEvent">
    <div class="today-tab flex" v-if="!isBor&&!isTypeDot&&!isBgDefine" :class="{'flex_space':isSpace}" :style="[styleObject,{'line-height':lhHeight+'px'}]">
      <div @click="tabActive = index" v-for="(item, index) in tabsLabel" :class="[{ activeTab: index === tabActive },'tab-item']" :key="index" ref="tab" :style="[styleObject]">
        <div :class="['tab-item',{ activeTab: index === tabActive }]" :style="[styleObject]">{{ item }}</div>
      </div>
      <tabsLine :type="multipleTab" :actIndex="tabActive">
        <div></div>
      </tabsLine>
    </div>

    <div class="flex" v-if="isTypeDot" :style="[styleObject,{'line-height':lhHeight+'px'}]">
      <div @click="tabActive = index" v-for="(item, index) in tabsLabel" :class="[{ 'tab__item-active': index === tabActive,'maR_l24':index !==0 },'tab__item']" :key="index">
        <div :class="[{ 'tab__item-active': index === tabActive},'tab__item']">{{ item }}</div>
      </div>
    </div>

    <div class="today-tab flex" v-if="isBor" :style="[styleObject,{'line-height':lhHeight+'px'}]">
      <div @click=" tabSelect(item,index) " v-for="(item, index) in tabsLabel" :key="index">
        <div class="tab-item tabs_bor" :style="{padding:pdBor}" :class="[{ 'active_tabs': index === tabActive,'bor_right bor_r_radius': tabsLabel.length-1 === index,'bor_l_radius': index===0}]">{{ item }}</div>
      </div>
    </div>

    <div :style="[styleDefineObj]">
      <ul class="tab-bg-box flex flex_space" v-if="tabList.length>0&&isBgDefine">
        <li v-for="(tab,index) in tabList" :key="tab.html" :class="{active:!isSearhTxt?codeType===tab.html:tabIndex==index}" @click="tabSelect(tab,index)">
          <div class="tabs-name">
            <a v-if="isUrl" :href="`/newsIndex`+tab.html+`1`">{{tab.name}}</a>
            <a v-else> {{tab.name}} </a>
            <div v-show="!isSearhTxt?codeType===tab.html:tabIndex==index" class="line"></div>
          </div>
        </li>

      </ul>
    </div>

  </div>
</template>

<script>
import tabsLine from "./tabsLine.vue";
// import { get } from 'node-cmd';

export default {
  props: { // 父辈向子辈传参
    // tabs 名称
    tabsLabel: {
      type: [Array],
      default: () => [
        '快递(100KG单价)',
        '空运(500KG单价)',
        'FBA(500KG单价)',
      ]
    },
    // tabs 名称 可自定义背景
    tabList: {
      type: [Array],
      default: () => []
    },

    // 是否 开启左右间隙 --下划线模式
    isSpace: {
      type: [Boolean],
      default: true,
    },
    // 最大宽度
    maxWidth: {
      type: [String, Number],
      default: 128 + 'px',
    },
    // 高度
    lhHeight: {
      type: [String, Number],
      default: '',
    },
    // 字体大小
    fontSize: {
      type: [String],
      default: 16 + 'px',
    },
    // 底部下划线内距
    PBottom: {
      type: [String],
      default: '',
    },
    // 底部描边
    borBottom: {
      type: [String],
      default: '',
    },
    // 大盒子的宽度
    minWidth: {
      type: [String, Number],
      default: 544 + 'px',
    },
    // 是否 描边全局模式
    isBor: {
      type: [Boolean],
      default: false,
    },
    // 是否 描边全局模式
    pdBor: {
      type: [String, Number],
      default: '',
    },
    // 是否 点模式tabs  涉及多定位时不使用（例如弹框）
    isTypeDot: {
      type: [Boolean],
      default: false,
    },
    // 涉及多定位时 不使用（例如弹框）
    multipleTab: {
      type: [String],
      default: 'line',
    },
    // v-model 值
    value: {},
    // 是否 选择自定义背景
    isBgDefine: {
      type: [Boolean],
      default: false,
    },
    // 是否显示跳转Url
    isUrl:{
      type: [Boolean],
      default: false,
    },
    // 自定义背景样式
    defineObj: {
      type: [Object],
      default: () => {
        return {
          def: {
            background: '',//背景颜色
            height: "31px",
            borTOPL: '',
            borTOPR: '',
            padding: "",
            widthItem: '',
            textAlign: '',
            isBg: '',
          }
        }
      },
    },
    // 是否有搜索功能
    isSearhTxt: {
      type: [Boolean],
      default: false,
    },
    //百运百科页面需要参数类型
    codeType:{
      type:[String],
      default:'quanbu'
    }
  },
  name: 'tabsItem',
  data() {
    return {
      tabIndex: 0
    }
  },
  created() { // 实例被创建之后执行代码

  },
  computed: { // 计算属性
    tabActive: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    styleObject() {
      return {
        "--max-width": this.maxWidth,//最大宽度
        "--border-bottom": this.borBottom,
        "--min-width": this.minWidth,
        "--font-size": this.fontSize,
        "--padding-bottom": this.PBottom,
      }
    },
    // 自定义
    styleDefineObj() {
      return {
        "--background-def": this.defineObj.def.background,
        "--height-def": this.defineObj.def.height,
        "--borTOP-L-def": this.defineObj.def.borTOPL,
        "--borTOP-R-def": this.defineObj.def.borTOPR,
        "--padding-def": this.defineObj.def.padding,
        "--width-Item-def": this.defineObj.def.widthItem,
        "--text-align-def": this.defineObj.def.textAlign,
        "--isBg-def": this.defineObj.def.isBg,
      }
    }
  },
  components: { // 组件的引用
    tabsLine
  },
  methods: { // 方法
    // 自定义背景
    tabSelect(tab, tabIndex) {
      this.$emit('tabSelect', tab,tabIndex)
      this.tabIndex = tabIndex
      // 有下划线、点、全边框
      this.tabActive = tabIndex
    },
     clickEvent() {
      this.$emit("click");
    },

  },
  mounted() { // 页面进入时加载内容

  },
  watch: { // 监测变化

  }
}
</script>

<style scoped lang='scss'>
// 主字体颜色
$font-lord: #333333;
// 次字体颜色
$font-bout: #777777;
// N次字体颜色
$font-minbout: #aaa;
// 描边颜色
$stroke-color-index1: #e0e0e0;
$stroke-color-index2: #f0f0f0;
// 按钮描边
$btn-colorBR: #dddddd;
// 选中动态颜色
$atv-colorBR: #0046b9;
// 字体大小
$font-24: 24px;
$font-18: 18px;
$font-16: 16px;
$font-14: 14px;
$font-13: 13px;

.tabsItem {
  min-width: var(--min-width);
  // margin-right: 114px; //首页--今日特价
}
.today-tab {
  // height: 24px;
  line-height: 24px;
  color: $font-bout;
  font-size: var(--font-size);
  cursor: pointer;
  position: relative;
  border-bottom: var(--border-bottom);
  padding-bottom: var(--padding-bottom);
  font-weight: normal;
}
.activeTab {
}

.tab-item {
  transition: color, transform 0.2s;
  // font-weight: 500;
  transform: scale(1);
  flex: 1;
  text-align: center;
  max-width: var(--max-width);
  box-sizing: border-box;
  &:hover {
    color: $atv-colorBR;
    // font-weight: 400;
  }
}
.tabs_bor {
  border-left: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}
.bor_right {
  border-right: 1px solid #dddddd;
}
.bor_r_radius {
  border-radius: 0 4px 4px 0;
}
.bor_l_radius {
  border-radius: 4px 0 0 4px;
}
.active_tabs {
  background: rgba(0, 70, 185, 0.08);
  border: 1px solid $atv-colorBR;
  color: $atv-colorBR;
}
.tab-item + .tab-item {
}

.tab-item.activeTab {
  color: $atv-colorBR;
  font-weight: 550;
  // transform: scale(1.1);
}

// 圆点样式
.tab__item {
  cursor: pointer;
  font-size: var(--font-size);
  position: relative;
  line-height: 22px;
  color: #777777;

  &::after {
    content: "";
    width: 0px;
    height: 0px;
    background: $atv-colorBR;
    border-radius: 50%;
    position: absolute;
    // bottom: -10px;
    left: -2%;
    transform: translateX(-50%);
  }
}
.tab__item.tab__item-active {
  color: $atv-colorBR;
  line-height: 22px;
  &::after {
    content: "";
    width: 4px;
    height: 4px;
    background: $atv-colorBR;
    border-radius: 50%;
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    transition: 0.5s all;
  }
}
// 可自定义背景
.tab-bg-box {
  background: var(--background-def);
  height: var(--height-def);
  border-top-left-radius: var(--borTOP-L-def);
  border-top-right-radius: var(--borTOP-R-def);
  padding: var(--padding-def);
  box-sizing: border-box;
  width: 100%;
  li {
    color: #333333;
    font-size: 16px;
    cursor: pointer;
    line-height: var(--height-def);
    width: var(--width-Item-def);
    text-align: var(--text-align-def);
    .tabs-name {
      flex: 1;
    }
  }
  .active {
    background: var(--isBg-def);
    color: #0046b9;
    background-position: 0px 3px;
    line-height: var(--height-def);
    font-weight: bold;
    .line {
      background: #0046b9;
      // max-width: var(--width-Item-def);
      height: 1px;
      // position: relative;
      // right: 8px;
    }
  }
}
</style>